module.exports = __webpack_public_path__ + "media/assets/img/comunicate-active-1745e459c86a7d5fba1fc0704a647870.svg";